export default __webpack_public_path__ + "static/media/item-carbon.269beb9a.jpg";